import { render, staticRenderFns } from "./selectGoods.vue?vue&type=template&id=39130e61&"
import script from "./selectGoods.vue?vue&type=script&lang=js&"
export * from "./selectGoods.vue?vue&type=script&lang=js&"
import style0 from "./selectGoods.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports